// extracted by mini-css-extract-plugin
module.exports = {"btn__print":"Cashier_btn__print__2Udvz"};